const routes = {
  MainPage: "/",
  ABOUT_US: "/aboutus",
  PRODUCTS: "/products",
  BLOG: "/blog",
  CONTACT_US: "/contactus",
  PRIVACY_POLICY: "/privacypolicy",
  TERM_CONDITION: "/termscondition",
  REFUND_POLICY: "/refundPolicy",
  SUPPORT: "support",
};

export default routes;
